import { AffiliatesTable } from '@features/user/affiliates/affiliateTable';
import { Affiliate } from '@src/types';

export const AffiliatesPayoutsPage = () => {
  const affiliates: Affiliate[] = [
    {
      name: 'John Doe',
      started: new Date().toISOString(),
      account: '2023Fxamdaion50K',
      accountNumber: 'BSBFASDF1234624DAS',
      renews: new Date().toISOString(),
      commissions: '$100',
    },
    {
      name: 'John Doe',
      started: new Date().toISOString(),
      account: '2023Fxamdaion50K',
      accountNumber: 'BSBFASDF1234624DAS',
      renews: new Date().toISOString(),
      commissions: '$100',
    },
    {
      name: 'John Doe',
      started: new Date().toISOString(),
      account: '2023Fxamdaion50K',
      accountNumber: 'BSBFASDF1234624DAS',
      renews: new Date().toISOString(),
      commissions: '$100',
    },
    {
      name: 'John Doe',
      started: new Date().toISOString(),
      account: '2023Fxamdaion50K',
      accountNumber: 'BSBFASDF1234624DAS',
      renews: new Date().toISOString(),
      commissions: '$100',
    },
  ];

  return <AffiliatesTable affiliates={affiliates} />;
};
